import type * as api from '@gitbook/api-client';

/**
 * Public Rpc API for any agent.
 */
export type AgentRpc = {
    /**
     * Post a message to the chat.
     */
    postMessage(message: api.AIMessageInput): Promise<void>;

    /**
     * Reset the whole state of the agent.
     */
    reset(): Promise<void>;
};

/**
 * Public Rpc API for the AgentChangeRequest.
 */
export type AgentChangeRequestRpc = {
    /**
     * Generate suggestions for an icon and a description for a page.
     */
    generatePageDescription(input: { pageId: string }): Promise<{
        icon: string;
        description: string;
    }>;
};
